import React, { useMemo } from "react";
import { DataTable, ErrorBox, Icon, LoadingBox, PageShell, Stat } from "../admin/_adminApi";
import { formatPkr, useReceipts } from "../Receipts/useReceipts";

const MonthlyReport = () => {
  const { receipts, loading, error } = useReceipts();

  const months = useMemo(() => {
    const byMonth = new Map();
    receipts.forEach((r) => {
      const d = new Date(r.created_at);
      if (Number.isNaN(d.getTime())) return;
      const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
      const row = byMonth.get(key) || {
        id: key,
        label: d.toLocaleDateString("en-PK", { month: "long", year: "numeric" }),
        count: 0,
        total: 0,
      };
      row.count += 1;
      row.total += Number(r.amount) || 0;
      byMonth.set(key, row);
    });
    return [...byMonth.values()].sort((a, b) => b.id.localeCompare(a.id));
  }, [receipts]);

  const now = new Date();
  const currentKey = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
  const current = months.find((m) => m.id === currentKey);

  return (
    <PageShell title="Monthly Report" subtitle="Medicine sales for each month, totalled from saved receipts.">
      <div className="ad-stats">
        <Stat tone="teal" icon={Icon.wallet} label="This month" value={formatPkr(current?.total)} />
        <Stat tone="blue" icon={Icon.file} label="Receipts this month" value={current?.count ?? 0} />
      </div>
      {error ? <ErrorBox error={error} /> : loading ? <LoadingBox /> : (
        <div className="ad-card">
          <DataTable
            rows={months}
            emptyText="No sales recorded yet."
            columns={[
              { label: "Month", render: (m) => <span className="t-strong">{m.label}</span> },
              { label: "Receipts", render: (m) => m.count },
              { label: "Sales", align: "right", render: (m) => formatPkr(m.total) },
            ]}
          />
        </div>
      )}
    </PageShell>
  );
};

export default MonthlyReport;
